let MIN_LENGTH_OF_PASSWORD = 8;
let MIN_CHAR_COMBINATIONS_FOR_PASSWORD = 3;

class PasswordResetController {
  constructor($scope, $state, passwordResetService, jwtHelper, $location, $http, pageLoaderService, $translate, authenticationService) {
    this.$scope = $scope;
    this.$state = $state;
    this.$location = $location;
    this.$http = $http;
    this.passwordResetService = passwordResetService;
    this.jwtHelper = jwtHelper;
    this.pageLoaderService = pageLoaderService;
    this.$translate = $translate;
    this.authenticationService = authenticationService;
    this.form = {};
    this.error = null;
    this.token = this.$location.search().requestToken;
    this.tokenExpired = this.isTokenExpired(this.token);

    let showExpiryMessage  = this.$location.search().expireMessage;

    if(showExpiryMessage) {
      this.setError('PASSWORD_EXPIRED');
    }
  }

  validateNewPassword() {
    this.matchNewPasswordAndConfirmPassword();
    this.validateNewPasswordMinLength();
    this.validateNewPasswordFormat();
  }

  validateComfirmPassword() {
    this.matchNewPasswordAndConfirmPassword();
  }

  validateNewPasswordFormat() {
    let password = this.form.newPassword;
    let hasNumbers = +/\d+/.test(password);
    let hasUpperCase = +/[A-Z]+/.test(password);
    let hasLowerCase = +/[a-z]+/.test(password);
    let hasSpecialChars = /[^A-Za-z0-9]/.test(password);
    let isInvalidFormat = password && (hasNumbers + hasUpperCase + hasLowerCase + hasSpecialChars < MIN_CHAR_COMBINATIONS_FOR_PASSWORD);

    if(isInvalidFormat) this.setError('EDIT_USER_PASSWORD_INVALID_ERROR');
  }

  validateNewPasswordMinLength() {
    let password      = this.form.newPassword;
    let invalidLength = true;

    if (password) {
      if(password.length >= MIN_LENGTH_OF_PASSWORD) invalidLength = false;
    }

    if(invalidLength) {
      this.setError('EDIT_PASSWORD_FIELD_MINLENGTH_ERROR');
    }
  }

  matchNewPasswordAndConfirmPassword() {
    let newPassword = this.form.newPassword;
    let confirmNewPassword = this.form.confirmNewPassword;

    if (newPassword && confirmNewPassword) {
      if(newPassword !== confirmNewPassword) this.setError('CONFIRM_PASSWORD_MATCH_ERROR');
    }
  }

  checkforEmptyFields() {
    let newPassword = this.form.newPassword;
    let confirmNewPassword = this.form.confirmNewPassword;

    if(newPassword !== confirmNewPassword) this.setError('CONFIRM_PASSWORD_MATCH_ERROR');
  }

  setError(error) {
    this.hasError = true;
    this.$translate(error).then(this.onErrorTranslated.bind(this));
  }

  onErrorTranslated(translation) {
    this.error = translation;
  }

  resetPassword() {
    let tokenExpired = this.isTokenExpired(this.token);

    this.hasError = false;
    this.tokenExpired = tokenExpired;
    this.validateNewPassword();
    this.checkforEmptyFields();

    if(!tokenExpired && !this.hasError) {
      this.authenticationService.setAuthHeader(this.token);

      this.pageLoaderService.show();

      this.passwordResetService.resetPassword(this.form.newPassword).then(
        this.onResetPasswordSuccess.bind(this),
        this.onResetPasswordFailure.bind(this)
      );
    }
  }

  onResetPasswordSuccess() {
    this.pageLoaderService.hide();
    this.authenticationService.clearCredentials();
    this.$state.go('login', { passwordUpdated: true });
  }

  onResetPasswordFailure(response) {
    this.pageLoaderService.hide();

    if(response.status === 406 && response.data.message === 'New Password Duplicate') {
      this.setError('EDIT_PASSWORD_DUPLICATE_ERROR');
    } else {
      this.setError('REQUEST_FAILURE');
    }
  }

  isTokenExpired(token) {
    let expired = true;

    try {
      expired = this.jwtHelper.isTokenExpired(token);
    } finally {
      expired;
    }
  }
}

PasswordResetController.$inject = [
  '$scope',
  '$state',
  'passwordResetService',
  'jwtHelper',
  '$location',
  '$http',
  'pageLoaderService',
  '$translate',
  'AuthenticationService'
];

export default PasswordResetController;



// WEBPACK FOOTER //
// ./app/components/passwordReset/passwordReset.controller.js